import React from 'react';
import {FieldInlineEditableProps} from "../../../render/inline-editable";

const debug = false
// const debug = "FieldDropdown_InlineEditable"

export default class FieldDropdown_InlineEditable extends React.Component<FieldInlineEditableProps, any> {

    private previousOption: any

    constructor(props:FieldInlineEditableProps) {
        super(props);

        const value = this.props.model[this.props.field.fieldId]

        this.state = {
            initialPropsValue   : value, // required to check if currentOption update needed on props changed
            currentOption       : props.field._getOption(value),
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        const value = props.model[props.field.fieldId]

        if (value !== state.initialPropsValue) {
            return {
                initialPropsValue   : value,
                currentOption       : props.field._getOption(value)
            }
        }

        return null // no changes
    }

    showPopover = (e?:React.SyntheticEvent) => {
        e?.stopPropagation()
        if (!this.state.showPopover) this.setState({showPopover: true})
    }

    hidePopover = () => {
        if (this.state.showPopover) this.setState({showPopover: false})
    }

    onOptionClick = (option:any) => {

        this.previousOption = this.state.currentOption;
        if (!option || _.isNil(option.value)) option = null;

        this.setState({
            currentOption: option
        }, () => {
            // if (this.props.onChange) this.props.onChange(_.get(option, 'value', null), this.onCancelChange);
            if (this.props.onChange) {
                this.props.onChange(_.get(option, 'value', null));
            }
            this.hidePopover()
        });
    }

    onCancelChange = () => {
        this.setState({
            currentOption: this.previousOption
        });
    }

    render() {
        const {field} = this.props;

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        });

        const isNotEmpty = this.state.currentOption && (field.hasOptionWithNullValue || !_.isNil(this.state.currentOption.value))
        debug && console.log(debug, 'render', isNotEmpty, this.props)

        // need check value because of none
        if (isNotEmpty) {
            return (
                <field.components.InlineValueNotEmpty
                    className       = {classes}
                    field           = {this.props.field}
                    size            = {this.props.size}
                    option          = {this.state.currentOption}
                    configOptions   = {this.props.configOptions}
                    onClick         = {this.showPopover}
                    onChange        = {this.onOptionClick}
                >
                    {this.state.showPopover &&
                        <field.components.PopoverMenu
                            {...this.props}
                            parent={this}
                        />
                    }
                </field.components.InlineValueNotEmpty>
            )
        } else {
            return (
                <field.components.InlineValueEmpty
                    className       = {classes}
                    field           = {this.props.field}
                    size            = {this.props.size}
                    configOptions   = {this.props.configOptions}
                    onClick         = {this.showPopover}
                >
                    {this.state.showPopover &&
                        <field.components.PopoverMenu
                            {...this.props}
                            parent={this}
                        />
                    }
                </field.components.InlineValueEmpty>
            )
        }
    }
}
